import './social_networks_view.coffee'
Namespace('Monitoring.Reports.Executive')

class Monitoring.Reports.Executive.InfluencersView extends Monitoring.Reports.Executive.SocialNetworksView
  id: 'influencers'

  initialize: (@options = {}) ->
    @users = @options.settings.influencers
    @title = "Influencers"
